import { render } from "./ShowingsPoster.vue?vue&type=template&id=9c038e40&scoped=true"
import script from "./ShowingsPoster.vue?vue&type=script&lang=js"
export * from "./ShowingsPoster.vue?vue&type=script&lang=js"

import "./ShowingsPoster.vue?vue&type=style&index=0&id=9c038e40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c038e40"]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QChip});
